import React, { useState } from "react";
import { helpers } from "@shared";
import classNames from "classnames";
import PropTypes from 'prop-types';
import { useSessionContext } from '@contexts';

const AutoEnroll = ({ action, label }) => {

    const [autoEnroll, setAutoEnroll] = useState(true);
    const { session } = useSessionContext();
    const { accountPreferences: { dueDay } } = session;

    return (
        <section className="p-4 justify-content-center pb-4">
            <h5>Enroll in Sunbound Pay every month</h5>
            <p>Have Sunbound pay your rent on the <b>{helpers.dayOrdinal(dueDay)} every month</b> going forward.</p>
            <div className="d-flex justify-content-evenly">
                <button
                    type="button"
                    className={classNames(`btn btn-lg`, { "btn-primary": autoEnroll }, { "btn-outline-primary": !autoEnroll })}
                    onClick={() => setAutoEnroll(true)}>Yes</button>
                <button
                    type="button"
                    className={classNames(`btn btn-lg`, { "btn-danger": !autoEnroll }, { "btn-outline-danger": autoEnroll })}
                    onClick={() => setAutoEnroll(false)}>No</button>
            </div>
            <button type="button" className="btn btn-primary w-100 mt-4" onClick={() => action(autoEnroll)}>{label}</button>
        </section >
    );
};

AutoEnroll.propTypes = {
    action: PropTypes.func,
    label: PropTypes.string
};

export default AutoEnroll;
